module.exports = __webpack_public_path__ + "static/media/avatar-default-picture.b6681619.png";